export default __webpack_public_path__ + "silver.png";